// Liens vers la documentation et les vidéos de Dust (02/10) : masqués dans la plateforme des
// apps. Ils menaient vers docs.dust.tt (en anglais, au nom de Dust) et la vidéo Wistia de la
// fenêtre « Synchronisation en cours » s'affichait comme une image cassée. Code amont gardé,
// derrière ce drapeau, pour garder le diff minimal.
export const DOC_AMONT_VISIBLE = false;
